import React, { useState, useEffect, lazy, Suspense } from "react";
import Loader from "../components/Loader/Loader";
import "./tab.css";
import { gaEvent } from "../utils/GoogleAnalytics/gatracking";
const Buylead = lazy(() => import("../components/Buylead/Buylead"));
const WorkOrder = lazy(() => import("../WorkOrder/WorkOrder"));
const History = lazy(() => import("../components/History/History"));
const ConnectSeller = lazy(() => import("../components/ConnectSeller/ConnectSeller"));

const Tabs = ({empid, ak, glid, workOrderDetails, wipWoCount, custId, selectedTab, selectedAccountRelatedTab, descId, disableConnectSellerBtn, phtype, connectSellerStatus}) => {

    const [activeTab, setActiveTab] = useState(1);
    const tabGAMapping = {
        1: "History/OCR Tab",
        2: "Buylead Tab",
        3: "Work Order Tab",
        4: "Connect Seller Tab"
    };

    const handleTabClick = (tabIndex) => {
        if (tabGAMapping[tabIndex]) {
            gaEvent(tabGAMapping[tabIndex], `${tabGAMapping[tabIndex]} click`, "click", tabGAMapping[tabIndex], glid);
        }
        setActiveTab(tabIndex); // Set the clicked tab as active
    };

    useEffect(() => {
        const r = document.querySelector(':root');
        if (selectedTab === '8') {
            r.style.setProperty('--tab-grid', '33% 33% auto')
            handleTabClick(1)
        } else {
            r.style.setProperty('--tab-grid', '50% 50%')
            handleTabClick(4)
        }
    }, [selectedTab])

    return (
        <>
        {
            (selectedTab === '8')
            ?
            <div className="btn-tabs cp">
                <span  className={`tab-link ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleTabClick(1)}>History/OCR</span>
                <span  className={`tab-link ${activeTab === 2 ? 'active' : ''}`} onClick={() => handleTabClick(2)}>Buylead</span>
                <span  className={`tab-link ${activeTab === 3 ? 'active' : ''}`} onClick={() => handleTabClick(3)}>Work Order({wipWoCount})</span>
            </div>
            :
            <div className="btn-tabs cp">
                <span  className={`tab-link ${activeTab === 1 ? 'active' : ''}`} onClick={() => handleTabClick(1)}>History/OCR</span>
                <span  className={`tab-link ${activeTab === 4 ? 'active' : ''}`} onClick={() => handleTabClick(4)}>Connect Seller</span>
            </div>
        }
        {            
            activeTab === 1 ? 
                <Suspense fallback={Loader}>
                    <History empid={empid} ak={ak} glid={glid} custId={custId} selectedTab={selectedTab} selectedAccountRelatedTab={selectedAccountRelatedTab} descId={descId} isDispSet={connectSellerStatus}/>
                </Suspense> :
            activeTab === 2 ? 
                <Suspense fallback={Loader}>
                    <Buylead glid={glid} empid={empid} ak={ak}/>
                </Suspense> :
            activeTab === 3 ? 
                <Suspense fallback={Loader}>
                    <WorkOrder empid={empid} ak={ak} glid={glid} workOrderDetails={workOrderDetails}/>
                </Suspense> :
            activeTab === 4 ? 
                <Suspense fallback={Loader}>
                    <ConnectSeller ak={ak} glid={glid} disableConnectSellerBtn={disableConnectSellerBtn} phtype={phtype} connectSellerStatus={connectSellerStatus}/>
                </Suspense> :
                null
        }
            
        </>
    );
};

export default Tabs;
